import { ReactComponent as Dropdown } from "../../../assets/icons/dropdown.svg";
import { OtherBranchData } from "../../../../common/hooks/console/otherBranch/useGetOtherBranch";
import { ReactComponent as Empty } from "../../../../common/assets/icons/empty.svg";

type OBTableProps = {
    showOBDetail: (customerIdx: number, customerName: string) => void;
    data?: OtherBranchData[];
    onSort: (field: string) => void;
};

const OBTable = ({ showOBDetail, data, onSort }: OBTableProps) => {
    return (
        <div className="h-full overflow-y-auto">
            <table className="table-auto w-full">
                {/* Header */}
                <thead className="text-gray2 text-sm border-y border-gray3 h-10">
                    <tr>
                        <th className="px-2">
                            <div className="flex items-center gap-4 justify-between">
                                <p>타지점명</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSort("customer_name")} />
                            </div>
                        </th>
                        <th className="px-2 w-[140px]">
                            <div className="flex items-center gap-4 justify-center">
                                <p>발주건수</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSort("order_count")} />
                            </div>
                        </th>
                        <th className="px-2 border-r border-gray4">
                            <div className="flex items-center justify-end gap-4">
                                <p>발주금액</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSort("order_amount")} />
                            </div>
                        </th>
                        <th className="px-2">미정산/완료 건수</th>
                        <th className="px-2 w-[140px]">
                            <div className="flex items-center justify-between">
                                <p>최근 정산일자</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSort("payment_date")} />
                            </div>
                        </th>
                        <th className="px-2 w-40 text-end">최근 정산금액</th>
                        <th className="px-2 w-40">
                            <div className="flex gap-4 justify-end">
                                <p>미정산금액</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSort("pending_amount")} />
                            </div>
                        </th>
                        <th className="px-2 w-20">
                            <div className="flex justify-between">
                                <p>상태</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSort("payment_status")} />
                            </div>
                        </th>
                    </tr>
                </thead>

                {/* Body */}
                <tbody>
                    {data && data.length > 0 ? (
                        data.map(item => (
                            <tr
                                key={`${item.customer_branch_idx}`}
                                onClick={() => showOBDetail(item.customer_branch_idx, item.customer_name)}
                                className="border-b border-gray4 text-sm h-[50px] cursor-pointer"
                            >
                                <td className="px-2 ">
                                    <div>
                                        <p className="font-bold text-primary1 text-base underline">{item.customer_name}</p>
                                        <p>{item.customer_manager_mobile}</p>
                                    </div>
                                </td>
                                <td className="px-2 text-center">{item.order_count}건</td>
                                <td className="px-2 text-end border-r border-gray4">{item.order_amount.toLocaleString()}원</td>
                                <td className="px-2 text-center">
                                    <div className="flex justify-center gap-1">
                                        <p className="text-error">{item.pending_count} 건</p>
                                        <p>/ {item.payment_complete_count} 건</p>
                                    </div>
                                </td>
                                <td className="px-2 text-center">{item.payment_date}</td>
                                <td className="px-2 text-end">{item.payment_amount.toLocaleString()} 원</td>
                                <td className="px-2 text-end text-error">{item.pending_amount.toLocaleString()} 원</td>
                                <td
                                    className={`px-2 text-center  bg-opacity-5 ${item.branch_payment_status_text === "미정산" ? "text-error bg-error" : "text-skyblue bg-skyblue"}`}
                                >
                                    {item.pending_amount === 0 && item.branch_payment_status_text === "미정산"
                                        ? "-"
                                        : item.branch_payment_status_text}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={10} className="text-center">
                                <div className="flex flex-col items-center gap-5 py-4 mt-52">
                                    <Empty />
                                    <p className="text-grayicon text-lg">등록된 내역이 없습니다.</p>
                                </div>
                            </td>
                        </tr>
                    )}
                </tbody>

                {/* Empty Data */}
                {/*<div className="items-center flex flex-col justify-center h-full">*/}
                {/*    <Empty />*/}
                {/*    <div className="text-center text-grayicon py-4 text-lg">등록된 내역이 없습니다.</div>*/}
                {/*</div>*/}
            </table>
        </div>
    );
};

export default OBTable;
